/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-08-17 15:59:55
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-23 15:57:07
 * @FilePath: \sea-page-game\src\utils\util.js
 */

const strs = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

/**
 * -------------------------
 * 获取当前的时间戳（ms）
 * ------------------------
 * @author: shupinghuang@rastar.com
 * @data: 2023-06-21 18:45:18
 */
export const curMillis = () => {
  let d = new Date();
  return d.getTime();
};

/**
 * -------------------------
 * 获取当前的时间戳（s）
 * ------------------------
 * @author: shupinghuang@rastar.com
 * @data: 2023-06-21 18:45:18
 */
export const curSeconds = () => {
  let millis = curMillis();
  return millis / 1000;
};

/**
 * -------------------------
 * 获取随机字符串
 * ------------------------
 * @author: shupinghuang@rastar.com
 * @data: 2023-06-21 18:45:18
 */
export const randomStr = (len) => {
  let length = len || 6;
  let result = new Array();
  let strLen = strs.length;
  for (var i = length; i > 0; --i) {
    result[i] = strs[Math.floor(Math.random() * strLen)];
  }
  return result.join("");
};

/**
 * -------------------------
 * 获取当前网址主域名
 * ------------------------
 * @author: jiansuiwang\@rastar.com
 * @date: 2023-11-23 15:22:18
 * @return 如果是非ip则返回.main domain
 */
export const getMainDomain = () => {
  let domain = window.location.hostname; // 获取当前网页的完整域名
  let domainParts = domain.split("."); // 将域名拆分为部分
  // 判断是否是 IP 地址或 localhost
  if (
    domainParts.length === 1 ||
    /^(?:localhost|(?:\d{1,3}\.){3}\d{1,3})$/.test(domain)
  ) {
    return domain; // 如果是 IP 地址或 localhost，直接返回当前域名
  }
  // 获取主域名，例如：如果是 www.example.com，则返回 .example.com
  return "." + domainParts.slice(-2).join(".");
};
